<template>
  <div class="tabs-shell">
    <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="clickTab">
      <el-tab-pane
          v-for="(item, index) in editableTabs"
          :key="item.name"
          :label="item.title"
          :name="item.name">
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  data() {
    return {}
  },
  computed: {
    editableTabs: {
      get() {
        return this.$store.state.menus.editableTabs
      },
      set(val) {
        this.$store.state.menus.editableTabs = val
      }
    },
    editableTabsValue: {
      get() {
        return this.$store.state.menus.editableTabsValue
      },
      set(val) {
        this.$store.state.menus.editableTabsValue = val
      }
    }
  },
  methods: {
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === 'Index') {
        return
      }
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }

      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter(tab => tab.name !== targetName);
      this.$router.push({name: activeName})

    },
    clickTab(target) {
      this.$router.push({name: target.name})
    }
  }
}
</script>

<style scoped>
.tabs-shell {
  margin-bottom: 16px;
  padding: 8px 10px 0;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(219, 232, 239, 0.78);
}

.tabs-shell >>> .el-tabs__header {
  margin: 0;
  border-bottom: 0;
}

.tabs-shell >>> .el-tabs__nav {
  border: 0;
}

.tabs-shell >>> .el-tabs__item {
  height: 36px;
  line-height: 36px;
  margin-right: 8px;
  border: 0 !important;
  border-radius: 999px 999px 0 0;
  color: #658096;
}

.tabs-shell >>> .el-tabs__item.is-active {
  color: #1878bd;
  background: #fff;
  box-shadow: 0 -2px 16px rgba(28, 93, 141, 0.08);
}
</style>
